import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=95516bf8&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95516bf8')) {
      api.createRecord('95516bf8', component.options)
    } else {
      api.reload('95516bf8', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=95516bf8&", function () {
      api.rerender('95516bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/confirm.vue"
export default component.exports